"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiService = void 0;
const request_1 = require("../core/request");
class AiService {
    /**
     * 获取 ai 相关指令配置
     * @returns any
     * @throws ApiError
     */
    static async getAiConfig() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/config`,
        });
        return result.body;
    }
    /**
     * @deprecated
     * 申请 ai 公测
     * @returns any
     * @throws ApiError
     */
    static async postAiApply() {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/ai/apply`,
        });
        return result.body;
    }
    /**
     * @deprecated
     * 是否参加 ai 公测
     * @returns any
     * @throws ApiError
     */
    static async getAiCheck() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/check`,
        });
        return result.body;
    }
    /**
     * 获取 AI 基于文件的对话记录
     * @param ossName 文件 oss 名称
     * @param spaceId 空间 id
     * @param blockId 块 id
     * @param propertyId 列 id，没有时不传
     * @returns any
     * @throws ApiError
     */
    static async getAiChatFile(ossName, spaceId, blockId, propertyId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/chat/file`,
            query: {
                'ossName': ossName,
                'spaceId': spaceId,
                'blockId': blockId,
                'propertyId': propertyId,
            },
        });
        return result.body;
    }
    /**
     * 删除 AI 基于文件的对话记录
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async deleteAiChatFile(requestBody) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/ai/chat/file`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 上传文件后 - 向量化进度状态
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postChatFileStatus(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/chat/${space}/file/status`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * AI 分析文件
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postChatFile(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/chat/file`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 AI 对话历史记录
     * @returns any
     * @throws ApiError
     */
    static async getAiChatHistory() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/chat/history`,
        });
        return result.body;
    }
    /**
     * 获取 flowus AI 对话历史记录
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getAiChatSpaceHistory(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/chat/${space}/history`,
        });
        return result.body;
    }
    /**
     * 获取指定 AI 对话记录
     * @param conversationId 会话组 uuid
     * @returns any
     * @throws ApiError
     */
    static async getAiChat(conversationId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/chat/${conversationId}`,
        });
        return result.body;
    }
    /**
     * 删除 AI 对话记录
     * @param conversationId 会话组 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async deleteAiChat(conversationId, requestBody) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/ai/chat/${conversationId}`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 同步 AI 对话记录
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async syncAiChat(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/ai/chat/sync`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 AI 备忘
     * @returns any
     * @throws ApiError
     */
    static async getAiChatMemo() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/chat/memo`,
        });
        return result.body;
    }
    /**
     * 获取 AI 备忘尚未同步到 notion 的记录
     * @returns any
     * @throws ApiError
     */
    static async getAiChatMemoNotion() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/chat/memo/notion`,
        });
        return result.body;
    }
    /**
     * 记录同步备忘到 notion 完成后的 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postAiChatMemoNotion(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/ai/chat/memo/notion`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 同步划选到 AI 备忘
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async syncAiChatActionMemo(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/ai/chat/sync/action/memo`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 AI prompt
     * @returns any
     * @throws ApiError
     */
    static async getAiChatPrompt() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/chat/prompt`,
        });
        return result.body;
    }
    /**
     * 新建 AI prompt
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postAiChatPrompt(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/ai/chat/prompt`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 更新 AI prompt
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async putAiChatPrompt(requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/ai/chat/prompt`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 删除 AI prompt
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async deleteAiChatPrompt(requestBody) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/ai/chat/prompt`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 AI action prompt
     * @returns any
     * @throws ApiError
     */
    static async getAiActionPrompt() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/chat/action`,
        });
        return result.body;
    }
    /**
     * 新建 AI prompt
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postAiActionPrompt(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/ai/chat/action`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 更新 AI prompt
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async putAiActionPrompt(requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/ai/chat/action`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 删除 AI action prompt
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async deleteAiActionPrompt(requestBody) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/ai/chat/action`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * AI 分析网页
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postChatLink(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/chat/link`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * AI 分析 PDF
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postChatPdf(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/chat/pdf`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * AI 分析字幕
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postChatSubtitle(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/chat/subtitle`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 空间 AI 临时活动
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getChatActivity(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/chat/${space}/activity`,
        });
        return result.body;
    }
    /**
     * 空间 AI 用量情况
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async postChatUsage(space) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/chat/${space}/usage`,
        });
        return result.body;
    }
    /**
     * 获取 AI 生成的历史
     * @returns any
     * @throws ApiError
     */
    static async getChatVision() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/chat/vision`,
        });
        return result.body;
    }
    /**
     * AI 生成图片
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postChatVision(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/chat/vision`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 是否有ai兑换券可领取
     * @param spaceId 空间id
     * @returns any
     * @throws ApiError
     */
    static async getWelfareToGive(spaceId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/welfareToGive`,
            query: {
                'spaceId': spaceId,
            },
        });
        return result.body;
    }
    /**
     * 领取老用户ai奖励
     * 领取老用户ai奖励
     *
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postWelfareToGive(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/ai/welfareToGive`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 AI 对话 PDF 对话历史记录
     * @returns any
     * @throws ApiError
     */
    static async getAipdfChatHistory() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/chat/pdf/history`,
        });
        return result.body;
    }
    /**
     * 获取空间中 PDF 历史记录
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpacePdfHistory(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/ai/${space}/history/pdf`,
        });
        return result.body;
    }
    /**
     * 复制模板 AI 次数奖励
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postAiCopyReward(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/ai/copy/reward`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 检查是否在知识库
     * @param block 文档块(或表单视图或评论) uuid
     * @returns any
     * @throws ApiError
     */
    static async infraCheckKnowledge(block) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/qa/knowledge/${block}/check`,
        });
        return result.body;
    }
    /**
     * 检查是否在问答白名单
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async checkQaWhiteList(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/qa/${space}/check`,
        });
        return result.body;
    }
    /**
     * 申请问答
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async applyQa(space) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/qa/${space}/apply`,
        });
        return result.body;
    }
    /**
     * 问答检索
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postQaRetrieval(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/qa/retrieval`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 订阅 | 知识库 | 帮助中心 检索
     * @param type 检索类型
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postQaRetrievalType(type, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/qa/retrieval/${type}`,
            body: requestBody,
        });
        return result.body;
    }
}
exports.AiService = AiService;
